<template>
  <div class="searchlist1">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <div class="top" @click="jumpDetail(item)">
          <div class="left">运单号:{{item.waybillNo}}</div>
          <div class="right"><van-icon class="myvanicon" name="arrow" /></div>
        </div>
        <div class="center" @click="jumpDetail(item)">
          <div class="l1">
            <div class="t1">{{item.jCity}}</div>
            <div class="t2">{{item.jContact}}</div>
          </div>
          <div class="c1">
            <div class="t1">
              <div :class="item.orderColor">
                <van-icon class="myvanicon m1" name="arrow" />
                <span class="span1"></span>
                <span class="span1"></span>
                <span class="span1"></span>
                <van-icon class="myvanicon" name="arrow" />
              </div>
            </div>
            <div class="t2"><span :class="item.orderColor">{{item.orderStatus}}</span></div>
          </div>
          <div class="r1">
            <div class="t1">{{item.dCity}}</div>
            <div class="t2">{{item.dContact}}</div>
          </div>
        </div>
        <div class="bottom">
          <div class="bin" v-if="item.routemark">{{item.routemark}}</div>
          <div class="bin2" v-if="item.payStatus === 'UNPAY'">
            <van-button class=" btn2" v-if="item.orderStatus === '已揽收'" type="danger">待支付</van-button>
            <van-button v-show="item.orderStatus === '未下单'" class="mybtn" @click.stop="cancelItem(item)" plain type="primary">取消</van-button></div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  import { sfList, cancelOrder } from '@/api/modules/sf'
  import { Dialog, Toast } from 'vant'
  export default {
    name: 'searchlist1',
    data() {
      return {
        loading: false,
        finished: false,
        dataList: [],
        searchOptions: {
          'waybillNo': '',
          'orderStatus': '已完成'
        },
        searchPage: {
          'page': 0,
          'pageSize': 10
        }
      }
    },
    created() {},
    methods: {
      setKey(key) {
        this.searchOptions.waybillNo = key
        this.searchPage.page = 1
        this.dataList = []
        this.loadData()
      },
      reSearch() {
        this.searchPage.page = 1
        this.dataList = []
        this.loadData()
      },
      onLoad() {
        this.searchPage.page++
        this.loadData()
      },
      cancelItem(item) {
        Dialog.confirm({
          title: '确认',
          message: '确认取消订单'
        })
          .then(() => {
            cancelOrder({
              'sf_order_id': item.sf_order_id
            }).then((res) => {
              if (res.data.status_code === 200) {
                Toast('撤单成功')
                this.reSearch()
              }
              else {
                Toast(res.data.message)
              }
            })
            // on confirm
          })
          .catch(() => {
            // on cancel
          })
      },
      loadData() {
        const params = Object.assign({}, this.searchPage, this.searchOptions)
        sfList(params).then((res) => {
          console.log(res)
          if (res.data.status_code === 200) {
            this.dataList.push(...res.data.list)
            console.log(this.dataList)
            // 这里表示最后一页
            if (this.searchPage.page * this.searchPage.pageSize >= res.data.total_count || res.data.list.length === 0) {
              this.loading = true
              this.finished = true
            }
            else {
              this.finished = false
              this.loading = false
            }
          }
        })
      },
      jumpDetail(item) {
        this.$router.push({ path: '/sf/expressdetail', query: { sf_order_id: item.sf_order_id, active: 2 }})
      }
    }
  }
</script>
<style lang="less">
  .van-list__finished-text{
    font-size:30px;
  }
</style>
<style lang="less" scoped>
  .searchlist1{
    .item{
      width: 720px;
      background: #FFFFFF;
      border-radius: 20px;
      margin:0px auto 20px auto;
      padding-bottom:20px;
      .top{
        height:70px;
        display:flex;
        border-bottom:1px solid #EEEEEE;
        .left{
          width:70%;
          font-weight: 400;
          font-size: 30px;
          color: #333333;
          padding-left:45px;
          line-height:70px
        }
        .right{
          flex:1;
          text-align:right;
          font-size:30px;
          line-height:70px;
          padding-right:20px;
          color:#A9A9A9;
        }
      }
      .bottom{
        .bin{
          width: 634px;
          min-height: 53px;
          background: #F4F5FB;
          border-radius: 10px;
          border: 0px solid #F099BA;
          margin:0px auto;
          font-weight: 400;
          font-size: 24px;
          color: #333333;
          line-height:53px;
          padding-left:20px;
          margin-bottom:20px;
        }
        .bin2{
          width: 634px;
          height: 53px;
          margin:0px auto;
          .mybtn{
            border-radius: 10px;
            border: 2px solid #C4C4C4;
            color:#C4C4C4;
            float:right;
            margin-right:20px;
          }
          .btn2{margin-right:0px;float:right;border-radius: 10px;}
        }
      }
      .center{
        height:130px;
        display:flex;
        .r1{
          width:30%;
          text-align:center;
          padding-top:25px;
          .t1{
            font-weight: 400;
            font-size: 30px;
            color: #333333;
            margin-bottom:15px;
            height:40px;
            line-height:40px;
          }
          .t2{
            font-weight: 400;
            font-size: 24px;
            color: #999999;
          }
        }
        .c1{
          flex:1;
          text-align:center;
          .t1{
            overflow:hidden;
            padding-top:20px;
            .m1{
              margin-left:50px;
            }
            .myvanicon{
              font-size:40px;
              font-weight:bolder;
              float:left;
              margin-right:10px;
            }
            .span1{
              display:block;
              width:15px;
              height:15px;
              margin-right:17px;
              border-radius: 15px;
              float:left;
              margin-top:10px;
            }
          }
          .t2{
            font-weight: 400;
            font-size: 24px;
            color: #E60012;
            line-height: 60px;
          }
        }
        .l1{
          width:30%;
          text-align:center;
          padding-top:25px;
          .t1{
            font-weight: 400;
            font-size: 30px;
            color: #333333;
            margin-bottom:15px;
          }
          .t2{
            font-weight: 400;
            font-size: 24px;
            color: #999999;
          }
        }
      }
    }
    .red{
      color:#E60012;
      .span1{
        background-color:#E60012 !important;
      }
    }
    .blue{
      color:#3B90FA;
      .span1{
        background-color:#3B90FA !important;
      }
    }
    .yellow{
      color:#F2AB00;
      .span1{
        background-color:#F2AB00 !important;
      }
    }
    .green{
      color:#68BE72;
      .span1{
        background-color:#68BE72 !important;
      }
    }
    .grey{
      color:#9C9C9C;
      .span1{
        background-color:#9C9C9C !important;
      }
    }
  }
</style>
